var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotHigh = function SvgNotHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: "not-high_svg___icon_7rbmn_1",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "not-high_svg__Not not-high_svg__high not-high_svg__24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#DADADA",
    className: "not-high_svg__Fill-Main"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M10 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM6 17h12v-2H6v2Z",
    className: "not-high_svg__Fill-Secondary",
    clipRule: "evenodd"
  }))));
};
export default SvgNotHigh;